var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("Works Collected In Your Current Visit")]),_c('Gallery',{attrs:{"works":_vm.$store.state.visitWorks,"showRemoveWork":true,"visitDate":"Current Visit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }